import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { CostCenterArticleRangeService } from '@mp/document-management/cost-center-article-ranges/data-access';

import { CostCenterArticleRangeAssignmentService, CostCenterArticleRangesForCostCenterService } from '../services';

export function provideCostCenterArticleRangesForCostCenterDataAccess(): EnvironmentProviders[] {
  return [
    makeEnvironmentProviders([
      CostCenterArticleRangesForCostCenterService,
      CostCenterArticleRangeAssignmentService,
      CostCenterArticleRangeService,
    ]),
  ];
}
